// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"722":"1530739e","5292":"91f69d5f","6198":"073b3f51"}[chunkId] + ".chunk.css";
};